module.exports = __webpack_public_path__ + "img/float-btn-poker.95f77168.svg";